import { injectBmsSlice } from '@/app/bmsApi';
import { toUser } from '@/features/auth/toUser';
import { User } from '@/features/auth/types';
import { CACHE_EXPIRATION_TIME } from '@/features/constants';

export const authApi = injectBmsSlice({
  baseUrl: '',
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    // The cookie is HttpOnly, so this endpoint is the SPA's only window into the session.
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/user',
      }),
      transformResponse: toUser,
    }),
  }),
});

export const { useLazyGetCurrentUserQuery } = authApi;
